import i18n from "../i18n";import { API_BASE_URL } from "./constant";

function storeSession(jwtData) {
  localStorage.setItem("token", jwtData.token);
  localStorage.setItem("accessToken", jwtData.token);
  if (jwtData.refreshToken) {
    localStorage.setItem("refreshToken", jwtData.refreshToken);
  }
  localStorage.setItem("email", jwtData.email);
  localStorage.setItem("name", jwtData.name);
  localStorage.setItem("id", jwtData.id);
  localStorage.setItem("role", jwtData.role);
}

async function login(email, password) {
  try {
    const response = await fetch(`${API_BASE_URL}/api/auth/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ email, password })
    });

    const result = await response.json();

    if (response.ok) {
      const jwtData = result.data;

      storeSession(jwtData);

      return {
        success: true,
        token: jwtData.token,
        user: {
          id: jwtData.id,
          name: jwtData.name,
          email: jwtData.email,
          role: jwtData.role
        }
      };
    } else {
      const errorMessage = result.message === "Bad credentials" ? "Invalid credentials." : result.message;
      return {
        success: false,
        error: errorMessage || "Invalid credentials."
      };
    }
  } catch (error) {
    console.error("Login error:", error);
    return {
      success: false,
      error: i18n.t("Network error. Please try again.")
    };
  }
}

async function refreshAccessToken() {
  const refreshToken = localStorage.getItem("refreshToken");
  if (!refreshToken) return null;

  const response = await fetch(`${API_BASE_URL}/api/auth/refresh`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({ refreshToken })
  });

  if (!response.ok) return null;

  const result = await response.json();
  if (!result.data?.token) return null;

  storeSession(result.data);
  return result.data.token;
}

async function register(formData) {
  try {
    const response = await fetch(`${API_BASE_URL}/api/auth/register`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(formData)
    });

    if (response.ok) {
      return {
        success: true,
        message: i18n.t("Registration successful")
      };
    } else {
      const data = await response.json();
      return {
        success: false,
        error: data.error || "Registration failed"
      };
    }
  } catch (error) {
    console.error("Registration error:", error);
    return {
      success: false,
      error: i18n.t("Network error. Please try again.")
    };
  }
}

async function getUserDetails(email) {
  try {
    const token = await refreshAccessToken().catch(() => localStorage.getItem("token"));
    const response = await fetch(
      `${API_BASE_URL}/api/users/details?email=${email}`,
      {
        headers: {
          Authorization: `Bearer ${token || localStorage.getItem("token")}`,
          "Content-Type": "application/json"
        }
      }
    );

    if (response.ok) {
      const data = await response.json();
      return {
        success: true,
        data
      };
    } else {
      const errorData = await response.json();
      return {
        success: false,
        error: errorData.error || "Failed to fetch user details"
      };
    }
  } catch (error) {
    console.error("Get user details error:", error);
    return {
      success: false,
      error: i18n.t("Network error. Please try again.")
    };
  }
}

async function logout() {
  try {
    const token = await refreshAccessToken().catch(() => localStorage.getItem("token"));
    const response = await fetch(`${API_BASE_URL}/api/auth/logout`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token || localStorage.getItem("token")}`
      }
    });

    if (response.ok) {
      console.log("Backend logout successful");
    }

  } catch (error) {
    console.error("Logout error:", error);
  } finally {
    const language = localStorage.getItem("i18nextLng");
    localStorage.clear();
    if (language) localStorage.setItem("i18nextLng", language);
    window.location.href = "/login";
  }
}

function clearLocalSession(redirectTo = "/login") {
  const language = localStorage.getItem("i18nextLng");
  const appLanguage = localStorage.getItem("appLanguage");
  localStorage.clear();
  if (language) localStorage.setItem("i18nextLng", language);
  if (appLanguage) localStorage.setItem("appLanguage", appLanguage);
  window.location.href = redirectTo;
}

async function changePassword(payload) {
  try {
    const token = await refreshAccessToken().catch(() => localStorage.getItem("token"));
    const response = await fetch(`${API_BASE_URL}/api/account/change-password`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token || localStorage.getItem("token")}`
      },
      body: JSON.stringify(payload)
    });

    const result = await response.json().catch(() => ({}));

    if (response.ok) {
      return {
        success: true,
        message: result.message || "Password changed successfully. Please log in again."
      };
    }

    return {
      success: false,
      error: result.message || result.error || "Could not change password"
    };
  } catch (error) {
    console.error("Change password error:", error);
    return {
      success: false,
      error: i18n.t("Network error. Please try again.")
    };
  }
}

async function requestPasswordResetOtp(email) {
  try {
    const response = await fetch(`${API_BASE_URL}/api/auth/forgot-password`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ email })
    });
    const result = await response.json().catch(() => ({}));
    return response.ok
      ? { success: true, message: result.message || "If an account exists for this email, a password reset OTP has been sent." }
      : { success: false, error: result.message || result.error || "Could not send OTP" };
  } catch (error) {
    console.error("Request password reset OTP error:", error);
    return { success: false, error: i18n.t("Network error. Please try again.") };
  }
}

async function verifyPasswordResetOtp(email, otp) {
  try {
    const response = await fetch(`${API_BASE_URL}/api/auth/forgot-password/verify-otp`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ email, otp })
    });
    const result = await response.json().catch(() => ({}));
    return response.ok
      ? { success: true, resetToken: result.data?.resetToken, message: result.message || "OTP verified successfully" }
      : { success: false, error: result.message || result.error || "Invalid or expired OTP" };
  } catch (error) {
    console.error("Verify password reset OTP error:", error);
    return { success: false, error: i18n.t("Network error. Please try again.") };
  }
}

async function resetForgottenPassword(payload) {
  try {
    const response = await fetch(`${API_BASE_URL}/api/auth/forgot-password/reset`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(payload)
    });
    const result = await response.json().catch(() => ({}));
    return response.ok
      ? { success: true, message: result.message || "Password reset successfully. Please log in with your new password." }
      : { success: false, error: result.message || result.error || "Could not reset password" };
  } catch (error) {
    console.error("Reset forgotten password error:", error);
    return { success: false, error: i18n.t("Network error. Please try again.") };
  }
}

function isAdminAuthenticated() {
  return !!localStorage.getItem("token") && localStorage.getItem("role") === "ROLE_ADMIN";
}

function isUserAuthenticated() {
  return !!localStorage.getItem("token") && localStorage.getItem("role") === "ROLE_USER";
}

function isInstructorAuthenticated() {
  return !!localStorage.getItem("token") && localStorage.getItem("role") === "ROLE_INSTRUCTOR";
}

function isAuthenticated() {
  return !!localStorage.getItem("token");
}

function getCurrentUser() {
  return {
    token: localStorage.getItem("token"),
    id: localStorage.getItem("id"),
    name: localStorage.getItem("name"),
    email: localStorage.getItem("email"),
    role: localStorage.getItem("role")
  };
}

function getAuthHeader() {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export const authService = {
  login,
  register,
  getUserDetails,
  logout,
  refreshAccessToken,
  clearLocalSession,
  changePassword,
  requestPasswordResetOtp,
  verifyPasswordResetOtp,
  resetForgottenPassword,
  isAdminAuthenticated,
  isUserAuthenticated,
  isInstructorAuthenticated,
  isAuthenticated,
  getCurrentUser,
  getAuthHeader
};
